// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "@rescript/std/lib/es6/curry.js";
import * as React from "react";
import * as Context from "../provider/Context.bs.js";
import * as $$Promise from "../Promise.bs.js";
import * as User_Api from "../user/User_Api.bs.js";
import * as Util_Logger from "../util/Util_Logger.bs.js";
import * as User_Context from "../user/User_Context.bs.js";
import * as User_Provider from "../user/User_Provider.bs.js";

function make(id) {
  var match = Context.I18n.getState(undefined);
  var locale = match.locale;
  var match$1 = React.useState(function () {
        return /* Idle */0;
      });
  var setStatus = match$1[1];
  var status = match$1[0];
  var token = Curry._1(User_Provider.Hook.useToken, undefined);
  var ssoEnv = User_Context.getEnv(undefined);
  React.useEffect((function () {
          if (id !== undefined && status === 0 && token !== undefined && typeof token !== "number") {
            Curry._1(setStatus, (function (param) {
                    return /* Loading */1;
                  }));
            $$Promise.$$catch(User_Api.ContinueWatching.get(ssoEnv, token, locale, id).then(function (nextEpisode) {
                      if (nextEpisode.TAG === /* Ok */0) {
                        var episode = nextEpisode._0;
                        Curry._1(setStatus, (function (param) {
                                return {
                                        TAG: /* Completed */0,
                                        _0: episode
                                      };
                              }));
                      } else {
                        Curry._1(setStatus, (function (param) {
                                return {
                                        TAG: /* Completed */0,
                                        _0: undefined
                                      };
                              }));
                      }
                      return Promise.resolve(undefined);
                    }), (function (error) {
                    Util_Logger.error2("Can't get nextEpisode in UseNextEpisode", error);
                    Curry._1(setStatus, (function (param) {
                            return {
                                    TAG: /* Error */1,
                                    _0: error
                                  };
                          }));
                    return Promise.resolve(undefined);
                  }));
          }
          
        }), [
        id,
        status,
        token,
        locale
      ]);
  return status;
}

export {
  make ,
}
/* react Not a pure module */
